import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { WorkerInputText } from '../WorkerInputText.jsx';

import { Description } from '../../Description';
import {
  FormElement,
  FormListItem,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { DateInput } from '../../DateInput.jsx';
import { CcusLineComponent } from '../../CcusFormComponent.jsx';

import {
  isNullOrUndefined,
  isNullOrUndefinedOrEmptyStr,
} from '../../../utilities/stringUtil';

import styles from '../../../styles/componentStyle/worker/workerInfo/ccus-worker-info-form.scss';
import careerUpCardImage from '../../../../src/images/img-career-up-card.jpg';

import { DIALOG_STATUS, TAB_KEY_STATUS, WORKER_PAGE_STATUS, DATE_TIME_FORMAT } from '../../../utilities/constants';

/**
 *
 * @param {string} name
 * @param {string} events
 * @param {string} value
 * @param {boolean} disabled
 * */
const SecurityCodeInputForm = ({
  name,
  events,
  value,
  disabled,
  tabKeyStatus,
}) => {
  return (
    <React.Fragment>
      {disabled === true && isNullOrUndefinedOrEmptyStr(value) === false ? (
        <span>●●●●</span>
      ) : (
        <React.Fragment>
          <input
            id={name}
            type='password'
            name={name}
            value={value}
            onChange={e => {
              events.setValue(e);
            }}
            onBlur={e => {
              events.validate(e.target.name);
            }}
            disabled={disabled}
            tabIndex={tabKeyStatus}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

/**
 * 作業員編集 画面 > CCUS連携情報
 * @param {object} formValues: 表示したいデータ群
 * @param {object} messages: バリデーションエラーメッセージ群
 * @param {string} supplementCcusRelationDescription: CCUSに関連する補足説明文
 * @param {boolean} disabledAll: 項目を編集することができるかどうか？
 * @param {function} events: ファンクション群(setValue, validate)
 * @param {object} pageStatus: 現在のページ情報
 * @param {string} correctCardInfoExpirationDate: 正しいCCUS技能者ID有効期限日
 * @param {string} currentCcusWorkerInfo: 現在のCCUS技能者情報
 */
export const CcusWorkerInfoForm = ({
  formValues,
  messages,
  supplementCcusRelationDescription,
  disabledAll,
  events,
  dialogStatus,
  pageStatus,
  correctCardInfoExpirationDate,
  currentCcusWorkerInfo,
}) => {
  const workerInputTextOnChange = e => {
    events.setValue(e);
  };

  const workerInputTextOnBlur = e => {
    events.validate(e.target.name);
  };

  // nullのままだとエラーになるので空文字にする
  if (isNullOrUndefined(formValues.security_code)) {
    formValues.security_code = '';
  }

  return (
    <React.Fragment>
      <FormListSubHeader title='CCUS連携情報' />
      {isNullOrUndefinedOrEmptyStr(supplementCcusRelationDescription) ===
        false && (
        <div className={styles.ccusDescriptionBlock}>
          <Description>
            <p className='ccus_description_message'>
              {supplementCcusRelationDescription}
            </p>
          </Description>
        </div>
      )}
      <FormListItem label='CCUS技能者ID'>
        <FormElement validate={messages.ccus_engineer_id}>
          <WorkerInputText
            name='ccus_engineer_id'
            value={formValues.ccus_engineer_id}
            messages={messages}
            disabled={disabledAll}
            onChange={workerInputTextOnChange}
            onBlur={workerInputTextOnBlur}
            tabKeyStatus={
              dialogStatus === DIALOG_STATUS.disabled.id
                ? TAB_KEY_STATUS.enabled
                : TAB_KEY_STATUS.disabled
            }
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='本人確認番号（セキュリティコード）'>
        <FormElement
          info='※本人確認番号は、建設キャリアアップカードの裏面、右下の4桁の数字です。'
          validate={messages.security_code}
        >
          {disabledAll && !formValues.security_code ? null : (
            <SecurityCodeInputForm
              name='security_code'
              value={formValues.security_code}
              events={events}
              disabled={disabledAll}
              tabKeyStatus={
                dialogStatus === DIALOG_STATUS.disabled.id
                  ? TAB_KEY_STATUS.enabled
                  : TAB_KEY_STATUS.disabled
              }
            />
          )}
        </FormElement>
      </FormListItem>
      <FormListItem label='有効期限'>
        <DateInput
          dateString={formValues.card_info_expiration_date}
          disabled={disabledAll && !(pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID && !currentCcusWorkerInfo.card_info_expiration_date)}
          onChangeValue={events.setCardInfoExpirationDate}
          isPreview={disabledAll && !(pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID && !currentCcusWorkerInfo.card_info_expiration_date)}
          message={messages.card_info_expiration_date}
          onBlur={() => workerInputTextOnBlur({ target: { name: 'card_info_expiration_date' } })}
          jpDelimiterChar={true}
          showPlaceholder={true}
          tabKeyStatus={TAB_KEY_STATUS.enabled}
        />
        {!_.isEmpty(correctCardInfoExpirationDate) && (
          <CcusLineComponent
            style={{ position: 'absolute', right: '50px' }}
            onClick={() => {
              events.setCardInfoExpirationDate(moment(correctCardInfoExpirationDate).format(DATE_TIME_FORMAT.slashDateFormat));
            }}
          >
            {moment(correctCardInfoExpirationDate).format(DATE_TIME_FORMAT.jaDateFormat)}
          </CcusLineComponent>
        )}
      </FormListItem>
      <FormListItem>
        <img
          className={styles.formListElementImage}
          src={careerUpCardImage}
          alt=''
        />
      </FormListItem>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/worker/form/CcusWorkerInfoForm.jsx